import React from 'react';
import { makeStyles, Box, useMediaQuery, useTheme } from '@material-ui/core';
import Image from 'next/image';
import blur from 'public/imgs/1x1.png';
import Carousel from 'react-multi-carousel';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useLayoutState } from 'components/shared/Layout';
import 'react-multi-carousel/lib/styles.css';

const useStyles = makeStyles((theme) => ({
  img: {
    width: '100%',
  },

  carousel: {
    position: 'relative',

    '& > ul': {
      listStyle: 'none',
      margin: '0',
      padding: '0',
      display: 'flex',
      height: 450,
      [theme.breakpoints.down('lg')]: {
        height: 400,
      },
      [theme.breakpoints.down('md')]: {
        height: 300,
      },
      [theme.breakpoints.down('sm')]: {
        height: 250,
      },
    },

    '& .arrow': {
      position: 'absolute',
      top: '40%',
      width: theme.spacing(6),
      height: theme.spacing(6),
      borderRadius: '50%',
      backgroundColor: 'rgba(48, 48, 48, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.common.white,
      cursor: 'pointer',

      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },

      '&.arrowLeft': {
        left: theme.spacing(3),
      },

      '&.arrowRight': {
        right: theme.spacing(3),
      },

      '& > svg': {
        fontSize: theme.typography.pxToRem(32),
      },
    },
  },
}));

const HeroGallery = ({ slidesArray = [] }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { layoutState } = useLayoutState();
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const ArrowLeft = (arrowLeftProps) => (
    <>
      <span {...arrowLeftProps} className="arrow arrowLeft">
        <ChevronLeftIcon />
      </span>
    </>
  );

  const ArrowRight = (arrowRightProps) => (
    <>
      <span {...arrowRightProps} className="arrow arrowRight">
        <ChevronRightIcon />
      </span>
    </>
  );

  return (
    <>
      <Box>
        <Carousel
          centerMode={layoutState.isCrawler ? undefined : !isMobile}
          swipeable
          ssr={layoutState.isCrawler} // means to render carousel on server-side.
          infinite
          keyBoardControl
          // deviceType={layoutState.deviceType}
          containerClass={classes.carousel}
          responsive={responsive}
          additionalTransfrom={-2}
          minimumTouchDrag={20}
          customTransition="transform 200ms ease-in"
          customLeftArrow={<ArrowLeft />}
          customRightArrow={<ArrowRight />}
        >
          {slidesArray.map((img, index) => (
            <Image
              key={`Hero-Gallery-${img.urls.large}`}
              className={classes.img}
              src={img.urls.large}
              alt={`Bike Image${index + 1}`}
              unoptimized
              placeholder="blur"
              blurDataURL={blur.src}
              layout="fill"
              objectFit="cover"
              priority={index === 0}
            />
          ))}
        </Carousel>
      </Box>
    </>
  );
};

export default HeroGallery;
